import { Component, EventEmitter, Output } from '@angular/core';
import { CurrentUserService } from 'src/app/utils';

@Component({
    selector: 'app-confirm-dispatcher-profile-activation',
    templateUrl: './confirm-dispatcher-profile-activation.component.html',
    styleUrls: ['./confirm-dispatcher-profile-activation.component.scss'],
    standalone: false
})
export class ConfirmDispatcherProfileActivationComponent {

    @Output() cancelEvent = new EventEmitter<void>();

    get userName(): string {
        return this.currentUserService.instantUser?.usr_name || '';
    }

    get userFirstName(): string {
        return this.userName
            .trim()
            .split(' ')[0];
    }

    constructor(
        private currentUserService: CurrentUserService
    ) { }

    cancel(): void {
        this.cancelEvent.emit();
    }

}
